import ApiService from "@/services/api.service";

// ACTIONS
export const LIST_USER = "listUser";
export const PAGINATED_LIST_USER = "paginatedListUser";
export const LIST_CLIENTS = "listClients";
export const LIST_MAIL_VIRTUALI = "listMailVirtuali";
export const LIST_UTENTI_ASSOCIABILI = "listUtentiAssociabili";
export const CREATE_USER = "createUser";
export const GET_USER = "getUser";
export const UPDATE_USER = "updateUser";
export const DELETE_USER = "deleteUser";
export const GET_USER_ATTIVITA = "getUserAttivita";
export const SEND_ONBOARDING_EMAIL = "sendOnboardingEmail";
export const SET_ERROR = "setError";

// MUTATIONS
export const SET_LIST_USERS = "setListUsers";
export const SET_LIST_CLIENTS = "setListClients";
export const SET_GLOBAL_LOADING = "setGlobalLoading";

const state = {
    listUsers: {},
    listClients: [],
    globalLoading: false,
    error: {},
};

const getters = {};

const actions = {
    [LIST_USER](context, query) {
        return new Promise((resolve) => {
            ApiService.get(`Users?${query}`)
                .then((res) => {
                    this.state.users.listUsers.length = 0;
                    context.commit(SET_LIST_USERS, res.data);
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
    [LIST_MAIL_VIRTUALI](context, query) {
        return new Promise((resolve) => {
            ApiService.get(`MailVirtuali/getEmailAssociabili?${query}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
    [LIST_UTENTI_ASSOCIABILI](context, query) {
        return new Promise((resolve) => {
            ApiService.get(`Users/getUtentiAssociabili?${query}`)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },

    [PAGINATED_LIST_USER](context, filters) {
        return new Promise((resolve) => {
            ApiService.post(`Users/Filtered`, filters)
                .then(({ data }) => {
                    context.commit(SET_LIST_USERS, data);
                    resolve(data);
                })
                .catch((res) => {
                    context.commit(SET_ERROR, res.data.error);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
    [LIST_CLIENTS](context) {
        return new Promise((resolve) => {
            ApiService.get(`Cliente/listDdl`)
                .then((res) => {
                    this.state.users.listClients.length = 0;
                    context.commit(SET_LIST_CLIENTS, res.data);
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
    [CREATE_USER](context, params) {
        context.commit(SET_GLOBAL_LOADING, true);

        return new Promise((resolve, reject) => {
            ApiService.post(`Users`, params)
                .then((res) => {
                    context.commit(SET_GLOBAL_LOADING, false);
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    context.commit(SET_GLOBAL_LOADING, false);
                    reject(response);
                });
        });
    },
    [GET_USER](context, id) {
        return new Promise((resolve) => {
            ApiService.download(`Users`, id)
                .then((res) => {
                    resolve(res.data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                });
        });
    },
    [UPDATE_USER](context, params) {
        context.commit(SET_GLOBAL_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.update(`Users`, params.id, params)
                .then((res) => {
                    context.commit(SET_GLOBAL_LOADING, false);
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    context.commit(SET_GLOBAL_LOADING, false);
                    reject(response);
                });
        });
    },
    [DELETE_USER](context, id) {
        context.commit(SET_GLOBAL_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.delete(`Users`, id)
                .then((res) => {
                    context.commit(SET_GLOBAL_LOADING, false);
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    context.commit(SET_GLOBAL_LOADING, false);
                    reject(response);
                });
        });
    },

    [GET_USER_ATTIVITA](context, { username, data }) {
        return new Promise((resolve, reject) => {
            const qs = data ? `?data=${data}` : "";
            ApiService.get(`Users/attivita/${encodeURIComponent(username)}${qs}`)
                .then(({ data: res }) => {
                    resolve(res.data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    reject(response);
                });
        });
    },

    [SEND_ONBOARDING_EMAIL](context, userId) {
        return new Promise((resolve, reject) => {
            ApiService.normalPost(`Users/${userId}/send-onboarding-email`)
                .then((res) => {
                    resolve(res);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response?.data?.message || response?.data?.error);
                    setTimeout(() => context.commit(SET_ERROR, ""), 5000);
                    reject(response);
                });
        });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.error = error;
    },

    [SET_LIST_USERS](state, users) {
        state.listUsers = Object.assign({}, users);
    },
    [SET_GLOBAL_LOADING](state, val) {
        state.globalLoading = val;
    },
    [SET_LIST_CLIENTS](state, clients) {
        state.listClients = clients;
    },
};

export default {
    state,
    actions,
    mutations,
    getters,
};
